const ProtectedRoute = ({ children }) => {
  return children;
};

export default ProtectedRoute;
